import { render } from "./professionals-form.vue?vue&type=template&id=24ffacdc&scoped=true"
import script from "./professionals-form.vue?vue&type=script&lang=js"
export * from "./professionals-form.vue?vue&type=script&lang=js"

import "./professionals-form.vue?vue&type=style&index=0&id=24ffacdc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ffacdc"]])

export default __exports__